var _ = require('underscore');
var utils = require('./utilities');
var Mapper = require('./mapper');
var Grading = require('./readworks-grading');
var metadataUtils = require('metadata-utils');
var metadata = require('core/metadata');
const OPTIONS_MAP = require('types/AssignmentOptions');
const ReadWorksAssignment = require('types/ReadWorksAssignment');

let addMinMaxLexileToPairedText = (article, d2) => {
	if (d2.productType === 'P') {
		let lexile = article.lexile && article.lexile[0];
		let minGradeOrder = article.minGradeOrder;
		let maxGradeOrder = article.maxGradeOrder;
		if (lexile) {
			if (lexile > d2.maxLexile || !d2.maxLexile) {
				d2.maxLexile = lexile;
			}
			if (lexile < d2.minLexile || !d2.minLexile) {
				d2.minLexile = lexile;
			}
		}
		if (maxGradeOrder > d2.maxGradeOrder || !d2.maxGradeOrder) {
			d2.maxGradeOrder = maxGradeOrder;
		}
		if (minGradeOrder < d2.minGradeOrder || !d2.minGradeOrder) {
			d2.minGradeOrder = minGradeOrder;
		}
	}
	return d2;
};

function SearchMapper() {}

SearchMapper.prototype.clientToServer = function (params) {
	// Remove "scratch" or "private" parameters (they end with a 0)
	var d = {};

	for (var key in params) {
		if (key[key.length - 1] !== '0') {
			d[key] = params[key];
		}
	}

	return d;
};

/**
 * Convert search results from server representation to client.
 * @param d         a search result such as {total:12, count:8, hits:[..]}
 *
 * @return an object with the array of hits converted to client side (read verbose) property names
 */
SearchMapper.prototype.serverToClient = function (d) {
	var d2 = {
		count: d.count,
		total: d.total
	};

	// when discoverySearch returns data in hits, all the properties
	// are arrays under "fields", when calling discoveryFindSimilars
	// all the properties are just normal values under "_source".
	// This function is used to wrap property references so we can
	// get rid of unwanted array wrappers when they are present.
	var stringNotArray = function (s) {
		if (s instanceof Array) {
			return s[0];
		} else {
			return s;
		}
	};

	function hitMapper(hit) {
		// discoverySearch search puts the values in "fields"
		// whereas discoveryFindSimilars puts the values in "_source"
		// find which one and use it (or use blank, since all the code
		// below tolerates missing properties)
		var fields = hit.fields || hit._source || {};

		var h2 = {
			id: hit._id,
			p: fields.p,
			uuid: hit._id,
			grades: fields.g || [],
			domains: fields.s || [],
			specialCollections: _.map(fields.cid ? [fields.cid] : [], function (cid) {
				return (
					metadata.allActiveNodesById['_' + cid] || {
						id: cid
					}
				);
			}),
			textType: fields.t && fields.t.length ? stringNotArray(fields.t) : undefined,
			img: fields.img ? stringNotArray(fields.img) : undefined,
			img_highres2: fields.img_highres2 || fields.img,
			imgAlt: fields.img_alt,
			title: fields.title ? stringNotArray(fields.title) : undefined,
			wordCount: fields.wordcount ? stringNotArray(fields.wordcount) : undefined,
			lexileCode: fields.lc ? stringNotArray(fields.lc) : undefined,
			lexile: fields.l,
			excerpt: fields.excerpt ? stringNotArray(fields.excerpt) : undefined,
			danteTextId: fields.danteTextId ? stringNotArray(fields.danteTextId) : undefined,
			productType: fields.pt,
			articles: fields.articles,
			features: fields.features,
			order: fields.order,
			sr: fields.sr,
			au: fields.au,
			minGrade: typeof fields.minGrade !== 'undefined' && metadata.gradesById['_' + fields.minGrade].text,
			maxGrade: typeof fields.maxGrade !== 'undefined' && metadata.gradesById['_' + fields.maxGrade].text,
			canonicalGrade: fields.canonical_grade,
			minLexile: fields.minLexile,
			maxLexile: fields.maxLexile,
			qsTotals: fields.qsTotals
				? {
						qs: fields.qsTotals[0],
						vocab: fields.qsTotals[1],
						total: fields.qsTotals[2]
					}
				: {
						qs: 0,
						vocab: 0,
						total: 0
					},
			sel: fields.sel || [],
			hasVideo: (fields.features || []).indexOf('video') !== -1,
			video: fields.video,
			subType: fields.subType,
			student_knowledge_framework: fields.student_knowledge_framework,
			genres: fields.genres,
			standards: fields.standards,
			firstPublished: fields.first_published,
			bookStudy: fields.bookstudy,
			dteGroups: (fields.dte_groups || []).map(group => {
				return {
					articles: Object.entries(group.articles).reduce((acc, [pid, article]) => {
						acc[pid] = {
							decodableTeacherEdition: {
								letterSoundFoci: article.decodable_teacher_edition.letter_sound_foci
							}
						};

						return acc;
					}, {})
				};
			})
		};

		if (hit.highlight) {
			h2.highlight = Object.values(hit.highlight).flat().join(' ');
		}

		if (h2.lexileCode === '0L') {
			h2.lexileCode = 'BR';
		}

		if (metadata) {
			if (h2.textType) {
				var tt = metadata.textTypeById['_' + h2.textType];
				if (tt) {
					h2.textTypeString = tt.name || '';
				} else {
					h2.textTypeString = '';
				}
			} else {
				h2.textTypeString = '';
			}

			let domainArray = (h2.domains || []).concat(h2.sel || []);
			h2.domainString = metadataUtils.domainsToString(domainArray, metadata);

			let libraryTopics = (h2.student_knowledge_framework || []).concat(h2.genres || []);
			h2.libraryTopics = metadataUtils.libraryTopicsToString(libraryTopics, metadata);
		} else {
			h2.domainString = '';
			h2.textTypeString = '';
		}

		if (fields.articles) {
			let rawArticles = {};
			let articles = {};

			if (fields.articles instanceof Array) {
				var articleArray = fields.articles;

				articleArray.forEach(function (article) {
					rawArticles[article.uuid] = article;
				});
			} else {
				rawArticles = fields.articles;
			}
			for (var key in rawArticles) {
				let article = rawArticles[key];
				articles[key] = hitMapper({
					fields: article
				});

				h2 = addMinMaxLexileToPairedText(articles[key], h2);
			}

			let articleList = [];

			for (var uuid in articles) {
				articleList.push(articles[uuid]);
			}

			if (articleList[0] && typeof articleList[0].order !== 'undefined') {
				articleList = _.sortBy(articleList, 'order');
			} else {
				articleList = _.sortBy(articleList, 'title');
			}

			h2.articles = articles;
			h2.articleList = articleList;
		}

		if (h2.hasVideo && h2.productType === 'P') {
			h2.grades = h2.articleList[0].grades;
		}

		return h2;
	}

	d2.hits = _.map(d.hits, hitMapper);

	utils.updateLatestProductVersions(d2.hits || []);

	return d2;
};

var beatrice = {
	product: new Mapper(
		{
			lc: 'lexileCode',
			wordcount: 'wordCount',
			ebook: 'ebook',
			text: 'text',
			title: 'title',
			au: 'audio',
			content: 'content',
			excerpt: 'excerpt',
			danteTextId: 'danteTextId',
			l: 'lexile',
			g: 'grades',
			k: 'skills',
			t: 'textType',
			ack: 'acknowledgment',
			vocab: 'vocab',
			questionSets: 'questionSets',
			s: 'domains',
			img: 'img',
			img_highres2: 'img_highres2',
			img_alt: 'imgAlt',
			p: 'id',
			uuid: 'uuid',
			a: 'authors',
			r: 'copyright',
			pt: 'productType',
			articles: 'articles',
			description: 'description',
			desc_in_lang: 'translatedDescription',
			sr: 'sr',
			order: 'order',
			minGrade: 'minGrade',
			maxGrade: 'maxGrade',
			canonical_grade: 'canonicalGrade',
			minLexile: 'minLexile',
			maxLexile: 'maxLexile',
			cid: 'cid',
			page_title: 'pageTitle',
			page_desc: 'pageDesc',
			cn: 'collectionName',
			byline: 'byline',
			subHeadline: 'subHeadline',
			newsDate: 'newsDate',
			subType: 'subType',
			st: 'subType',
			banner: 'banner',
			'qsTotals.s': 'qsTotals.qs',
			'qsTotals.v': 'qsTotals.vocab',
			isStepRead: 'isStepRead',
			sel: 'sel',
			alphaTitle: 'alphaTitle',
			exp: 'experiments',
			video: 'video',
			features: 'features',
			status: 'status',
			genres: 'genres',
			student_knowledge_framework: 'student_knowledge_framework',
			supplemental_texts: 'supplemental_texts',
			word_detective: 'word_detective',
			meaning_mapper: 'meaning_mapper',
			standards: 'standards',
			dte_groups: 'dteGroups',
			decodable_teacher_edition: 'decodableTeacherEdition',
			'decodable_teacher_edition.alignment_fundations_unit': 'decodableTeacherEdition.alignmentFundationsUnit',
			'decodable_teacher_edition.decodability_details': 'decodableTeacherEdition.decodabilityDetails',
			'decodable_teacher_edition.decodability_percentage': 'decodableTeacherEdition.decodabilityPercentage',
			'decodable_teacher_edition.decodability_percentage_for_target_skill': 'decodableTeacherEdition.decodabilityPercentageForTargetSkill',
			'decodable_teacher_edition.high_frequency_and_trick_words': 'decodableTeacherEdition.highFrequencyAndTrickWords',
			'decodable_teacher_edition.letter_sound_foci': 'decodableTeacherEdition.letterSoundFoci',
			'decodable_teacher_edition.non_decodable_challenge_words': 'decodableTeacherEdition.nonDecodableChallengeWords',
			'decodable_teacher_edition.prereq_letter_sound_foci': 'decodableTeacherEdition.prereqLetterSoundFoci',
			bookstudy: 'bookStudy',
			ts: 'textSet',
			'ts.pid': 'textSet.pid',
			'ts.title': 'textSet.title',
			'ts.subType': 'textSet.subType',
			'ts.category': 'textSet.category',
			'ts.book': 'textSet.book',
			langs: 'languages',
			lang: 'language',
			has_extended_chars: 'hasExtendedCharacters'
		},
		{
			postServerToClient: function (d, d2) {
				d2.authors = d2.authors || []; // make sure it's empty, not undefined
				var skillsById = metadata.skillsById;
				var qso = [];
				let comp = [];
				let skill = [];
				let vocab = [];

				_.each(d2.questionSets, function (s) {
					s.isSkill = false;
					s.isVocab = s.vocabularyWord || false;

					_.each(s.k || [], function (k) {
						if (skillsById['_' + k]) {
							s.isSkill = true;
						}
					});

					s.isComp = !s.isSkill && !s.isVocab;

					if (s.isComp) {
						comp.push(s);
					} else if (s.isSkill) {
						skill.push(s);
					} else if (s.isVocab) {
						vocab.push(s);
					}
				});

				let titleSort = function (a, b) {
					if (a.title < b.title) {
						return -1;
					} else if (a.title > b.title) {
						return 1;
					} else {
						return 0;
					}
				};

				comp.sort(titleSort);
				skill.sort(titleSort);
				vocab.sort(titleSort);

				qso = comp.concat(skill.concat(vocab));
				d2.questionSetsOrdered = qso;

				if (d2.minGrade) {
					let minGrade = metadata.gradesById['_' + d2.minGrade];
					let maxGrade = metadata.gradesById['_' + d2.maxGrade];
					let displayGrade = metadata.gradesById['_' + d2.grades[0]];
					d2.minGrade = minGrade.text;
					d2.maxGrade = maxGrade.text;
					d2.minGradeOrder = minGrade.order;
					d2.maxGradeOrder = maxGrade.order;
					d2.displayGradeOrder = displayGrade.order;
				} else if (d2.grades && d2.grades.length) {
					if (d2.grades.length === 1) {
						let gradeMeta = metadata.gradesById['_' + d2.grades[0]];
						d2.minGrade = gradeMeta.text;
						d2.maxGrade = gradeMeta.text;
						d2.minGradeOrder = gradeMeta.order;
						d2.maxGradeOrder = gradeMeta.order;
					} else {
						d2.grades.forEach(g => {
							let gradeMeta = metadata.gradesById['_' + g];
							if (gradeMeta.order > d2.maxGradeOrder || !d2.maxGradeOrder) {
								d2.maxGrade = gradeMeta.text;
								d2.maxGradeOrder = gradeMeta.order;
							}
							if (gradeMeta.order < d2.minGradeOrder || !d2.minGradeOrder) {
								d2.minGrade = gradeMeta.text;
								d2.minGradeOrder = gradeMeta.order;
							}
						});
					}
				}

				if (d2.articles) {
					d2.articleList = [];
					d2.allArticles = {};

					for (let key in d2.articles) {
						let a = beatrice.product.serverToClient(d2.articles[key]);

						a.uuid = key;

						d2 = addMinMaxLexileToPairedText(a, d2);

						d2.articles[key] = a;
						d2.allArticles[key] = a;
						d2.articleList.push(a);
					}

					if (d2.articleList[0] && typeof d2.articleList[0].order !== 'undefined') {
						d2.articleList = _.sortBy(d2.articleList, 'order');
					} else {
						d2.articleList = _.sortBy(d2.articleList, 'title');
					}

					// Patch holes in product json that are present in search hits.
					if (!d2.grades) {
						let grades = [];
						d2.articleList.forEach(text => {
							if (text.grades && text.grades.length) {
								text.grades.forEach(g => {
									if (grades.indexOf(g) === -1) {
										grades.push(g);
									}
								});
							}
						});
						d2.grades = grades;
					}
					if (!d2.wordCount) {
						let wordCount = 0;
						d2.articleList.forEach(text => {
							if (text.wordCount) {
								wordCount += text.wordCount;
							}
						});
						d2.wordCount = wordCount;
					}
					if (!d2.domains) {
						let domains = [];
						d2.articleList.forEach(text => {
							if (text.domains && text.domains.length) {
								text.domains.forEach(domain => {
									if (domains.indexOf(domain) === -1) {
										domains.push(domain);
									}
								});
							}
						});
						d2.domains = domains;
					}
				}

				if (d2.cid) {
					d2.specialCollections = [
						_.assign({}, metadata.allActiveNodesById['_' + d2.cid], {
							id: d2.cid
						})
					];
				}

				if (d2.img) {
					d2.thumbnail = d2.img;
				}

				if (!d2.img_highres2) {
					d2.img_highres2 = d2.img;
				}

				if (d2.textType) {
					let tt = metadata.textTypeById['_' + d2.textType];
					if (tt) {
						d2.textTypeString = tt.name || '';
					} else {
						d2.textTypeString = '';
					}
				} else {
					let textTypes = [];
					d2.textTypeString = '';
					if (d2.productType === 'P' && d2.articleList && d2.articleList.length) {
						d2.articleList.forEach(text => {
							text.textType.forEach(textType => {
								if (textType && textTypes.indexOf(textType) === -1) {
									textTypes.push(textType);
								}
							});
						});
						d2.textTypeString = textTypes.reduce((acc, textType, idx) => {
							let tt = metadata.textTypeById['_' + textType];
							if (tt && tt.name) {
								if (acc.length && idx > 0) {
									acc += ' & ';
								}
								acc += tt.name;
							}
							return acc;
						}, '');
					}
				}

				if (d2.lexileCode && d2.lexileCode.length && d2.lexileCode[0] === '0L') {
					d2.lexileCode = ['BR'];
				}

				if (d2.features && d2.features.indexOf('video') !== -1) {
					d2.hasVideo = true;
					if (d2.productType === 'P') {
						d2.g = d2.articleList[0].grades;
					}
				}

				if (d2.supplemental_texts) {
					for (let supplementalType in d2.supplemental_texts) {
						for (let key in d2.supplemental_texts[supplementalType]) {
							let a = beatrice.product.serverToClient(d2.supplemental_texts[supplementalType][key]);

							if (a.id) {
								delete a.id;
							}
							a.uuid = key;
							d2 = addMinMaxLexileToPairedText(a, d2);
							d2.supplemental_texts[supplementalType][key] = a;
							d2.allArticles[key] = a;
						}
					}
				}

				d2.topics = d2.domains;
				let domainArray = (d2.domains || []).concat(d2.sel || []);
				d2.domainString = metadataUtils.domainsToString(domainArray, metadata);

				let libraryTopics = (d2.student_knowledge_framework || []).concat(d2.genres || []);
				d2.libraryTopics = metadataUtils.libraryTopicsToString(libraryTopics, metadata);
				if (d2.dteGroups) {
					for (const dteGroup of d2.dteGroups) {
						for (const key in dteGroup.articles) {
							let a = beatrice.product.serverToClient(dteGroup.articles[key]);

							a.uuid = key;
							a.decodableTeacherEdition = a.decodableTeacherEdition || {};

							dteGroup.articles[key] = a;
							d2.allArticles[key] = a;
						}
					}
				}

				if (d2.languages) {
					d2.languages = d2.languages.map(lang => lang.toLowerCase());
				}

				if (d2.language) {
					d2.language = d2.language.toLowerCase();
				}
			}
		}
	),
	class: new Mapper(
		{
			cc: 'classCode',
			s: 'status',
			n: 'name',
			p: 'productId',
			g: 'grade',
			rt: 'rosterType',
			l: 'locked',
			c: 'created',
			z: 'roster',
			uid: 'uid',
			as: 'settings',
			newClassName: 'newClassName',
			'as.dcp': 'settings.disableCopyPaste',
			'as.gcp': 'settings.publishToGoogleClassroom',
			'as.bokEdit': 'settings.bokEdit',
			'as.showResults': 'settings.showResults',
			'as.library': 'settings.library',
			'as.assignmentHideLibrary': 'settings.assignmentHideLibrary',
			gcid: 'gcid',
			token: 'token'
		},
		{
			postServerToClient: function (d, d2) {
				d2.studentCount = _.uniq(d.z).length;
			}
		}
	),
	roster: new Mapper(
		{
			n: 'name',
			rt: 'rosterType',
			s: 'students',
			cc: 'classCode',
			gcid: 'gcid'
		},
		{
			postServerToClient: function (d, d2) {
				d2.students = _.map(d2.students, function (s) {
					let student = beatrice.student.serverToClient(s);
					if (!student.firstName && !student.lastName) {
						student.firstName = '[Unknown Name]';
					}
					return student;
				});
				d2.students.sort(function (a, b) {
					if (a.lastName > b.lastName) {
						return 1;
					} else if (a.lastName < b.lastName) {
						return -1;
					} else if (a.firstName > b.firstName) {
						return 1;
					} else if (a.firstName < b.firstName) {
						return -1;
					} else {
						return 0;
					}
				});
			}
		}
	),
	student: new Mapper({
		l: 'lastName',
		f: 'firstName',
		ll: 'lastLogin',
		e: 'username',
		ell: 'ell',
		uid: 'uid',
		ad: 'accountDisabled'
	}),
	classUnenrollStudent: new Mapper({
		cc: 'classCode',
		uid: 'uid'
	}),

	studentAccount: new Mapper(
		{
			u: 'username',
			p: 'password',
			f: 'firstName',
			l: 'lastName',
			cc: 'classCode',
			uid: 'uid',
			token: 'token',
			ell: 'ell',
			c: 'created',
			org: 'organization',
			rmf: 'rmFont',
			gcAddon: 'gcAddon'
		},
		{
			postClientToServer: function (d, d2) {
				if (d2.cc) {
					d2.cc = d2.cc.toUpperCase();
				}
			},
			postServerErrorToClient: function (resBody, err2) {
				if (resBody.code === 1024) {
					err2.username = err2.username || {};
					err2.username.invalid = true;
				}

				if (resBody.code == 1015) {
					err2.formError = {
						name: 'student-password',
						message: 'This password is incorrect.'
					};
				}
			}
		}
	),

	addCoteacher: new Mapper(
		{
			cc: 'cc',
			e: 'e'
		},
		{
			postServerErrorToClient: function (resBody, err2) {
				if (resBody.code == 1087) {
					err2.formError = {
						name: 'coteacherEmail',
						message: 'This coteacher has already been added.'
					};
				}
				if (resBody.code == 1098) {
					err2.formError = {
						name: 'coteacherEmail',
						message: 'You have reached your invitation limit. Please try again later.'
					};
				}
			}
		}
	),
	account: new Mapper(
		{
			e: 'email',
			p: 'password',
			cp: 'currentPassword',
			f: 'firstName',
			l: 'lastName',
			recaptcha: 'recaptcha',
			r: 'role',
			g: 'grades',
			sn: 'schoolName',
			sid: 'schoolId',
			ci: 'city',
			co: 'country',
			s: 'state',
			remote: 'schoolRemoteness',
			st: 'shareAboutTeaching',
			k12: 'k12',
			token: 'token',
			fromDrupal: 'fromDrupal',
			eid: 'eid',
			uid: 'uid',
			v: 'verified',
			print: 'print',
			digital: 'digital',
			project: 'project',
			experiments: 'experiments',
			org: 'organization',
			updated: 'updated',
			legacy: 'legacy',
			campaign: 'campaign',
			type: 'type',
			clever: 'clever',
			google: 'google',
			curriculum: 'curriculum',
			ssoSystems: 'ssoSystems',
			milestones: 'milestones'
		},
		{
			postServerToClient: function (d, d2) {
				if (!d2.shareAboutTeaching) {
					d2.shareAboutTeaching = [];
				}

				d2.gradeSelections = metadata.gradeSelections;
				_.each(d2.gradeSelections, function (gs) {
					if (_.indexOf(d2.grades, gs.id) !== -1) {
						gs.selected = true;
					}
				});

				if (d2.schoolName && d2.schoolId) {
					d2.schoolIdName = d2.schoolId + ':' + d2.schoolName;
				} else {
					d2.schoolIdName = '-1';
				}

				if (d2.updated) {
					d2.updated = beatrice.account.teacherGetAccount.serverToClient(d2.updated);
				}
			},
			postClientToServer: function (d, d2) {
				// FIXME: Vue.js <select v-model> always converts values to strings
				if (typeof d2.r !== 'undefined' && d2.r !== null && d2.r !== '') {
					d2.r = parseInt(d2.r, 10);
				}

				// grade selections is used to show a matrix of checkbox controls
				// if found, convert it to an array of IDs to send to the server
				if (d.gradeSelections) {
					d2.g = [];
					_.each(d.gradeSelections, function (gs) {
						if (gs.selected) {
							d2.g.push(gs.id);
						}
					});
				}

				if (d2.g && d2.g.length) {
					d2.g = _.map(d2.g, function (g) {
						return parseInt(g, 10);
					});
				}

				var idNameMatch = utils.splitSchoolIdName(d.schoolIdName);
				if (idNameMatch) {
					d2.sid = idNameMatch[1];
					d2.sn = idNameMatch[2];
				} else if (d.schoolIdName && d.schoolIdName == '-1') {
					d2.sid = null;
					d2.sn = null;
				}
			},
			postServerErrorToClient: function (resBody, err2) {
				if (resBody.code === 1006) {
					err2.formError = {
						name: 'email',
						message: 'You already have an account. Please log in.'
					};
				}

				if (resBody.code == 1024) {
					err2.formError = {
						name: 'email',
						message: 'This email is not found. Please sign up.'
					};
				}

				if (resBody.code == 1015) {
					err2.formError = {
						name: 'password',
						message: 'This password is incorrect.'
					};
				}
			}
		}
	),
	search: new SearchMapper(),
	recommendation: {
		studentLibrarySimilar: new SearchMapper()
	},
	discovery: {
		findSimilars: new SearchMapper(),
		searchProduct: new SearchMapper(),
		searchLibrary: new SearchMapper(),
		getLibraryProductsByGenre: new SearchMapper(),
		getLibraryProductsBySKF: new SearchMapper(),
		getNewLibraryProducts: new SearchMapper(),
		getPopularLibraryProducts: new SearchMapper(),
		libraryReadNext: new SearchMapper(),
		searchSchool: new Mapper(
			{
				total: 'total',
				hits: 'hits',
				count: 'count',
				zip: 'zip'
			},
			{
				postServerToClient: function (d, d2) {
					d2.hits = _.map(d2.hits || [], function (h) {
						return h._source || {};
					});
				}
			}
		)
	},
	assignmentCreateClass: new Mapper({
		n: 'newClassName'
	}),
	assignment: {
		updateAssignmentDeadline: new Mapper(
			{
				cc: 'classCode',
				ed: 'deadline',
				edd: 'duedate',
				aid: 'assignmentId',
				'updated.ed': 'updated.deadline',
				'updated.u': 'updated.startDate',
				token: 'token'
			},
			{
				postClientToServer: function (d, d2) {
					if (d.productType !== 'AAD') {
						d2.edd = d2.ed;
						delete d2.ed;
					}
				}
			}
		),

		teacherGetAssignmentResultsSummary: new Mapper(
			{
				cc: 'classCode',
				aid: 'assignmentId',
				opts: 'options',
				p: 'productId',
				ak: 'studentsSubmitted',
				sc: 'studentCount',
				articles: 'articles',
				d: 'startDate',
				ed: 'deadline',
				edd: 'duedate',
				'qmap[k].n': 'questionSets[k].name',
				'smap[k].qsNotes[k]': 'students[k].generalNotes[k]',
				'smap[k].f': 'students[k].firstName',
				'smap[k].l': 'students[k].lastName',
				'smap[k].s': 'students[k].submitted',
				'smap[k].ts': 'students[k].timeSubmitted',
				'smap[k].edd': 'students[k].edd',
				'smap[k].ans[k][k].qt': 'students[k].answers[k][k].questionType',
				'smap[k].ans[k][k].t': 'students[k].answers[k][k].answerText',
				'smap[k].ans[k][k].f': 'students[k].answers[k][k].teacherNote',
				'smap[k].ans[k][k].aid': 'students[k].answers[k][k].answerId',
				'smap[k].ans[k][k].s': 'students[k].answers[k][k].score',
				'smap[k].ans[k][k].r[k].t': 'students[k].answers[k][k].subQuestions[k].answerText',
				'smap[k].ans[k][k].r[k].s': 'students[k].answers[k][k].subQuestions[k].score',
				'smap[k].aad[k].b': 'students[k].aad[k].b',
				'smap[k].aad[k].bets': 'students[k].aad[k].bets',
				'smap[k].aad[k].brev': 'students[k].aad[k].brev',
				'smap[k].aad[k].n': 'students[k].aad[k].n',
				'smap[k].aad[k].s': 'students[k].aad[k].s',
				'smap[k].aad[k].tf': 'students[k].aad[k].tf',
				'smap[k].aad[k].tn': 'students[k].aad[k].teacherNote',
				'smap[k].aad[k].brevts': 'students[k].aad[k].brevts',
				'smap[k].va.rtw': 'students[k].vocabularyActivity.rtw',
				'smap[k].va.wb': 'students[k].vocabularyActivity.word_builder',
				'smap[k].va.wc': 'students[k].vocabularyActivity.word_changer',
				'smap[k].va.wm': 'students[k].vocabularyActivity.word_matcher',
				'smap[k].gcasid': 'students[k].gcaSubmissionId',
				gcid: 'gcid',
				gca: 'gca',
				'gca.aid': 'gca.attachmentId',
				'gca.iid': 'gca.itemId',
				graphicOrganizers: 'graphicOrganizers',
				sbm: 'suidsSubmitted',
				shwres: 'showResults',
				s: 'assignmentStatus',
				closed: 'closed',
				t: 'type',
				g: 'group',
				ts: 'textSet',
				'ts.pid': 'textSet.pid',
				'ts.title': 'textSet.title',
				'ts.subType': 'textSet.subType',
				'ts.category': 'textSet.category',
				'ts.book': 'textSet.book'
			},
			{
				postServerToClient: function (d, d2) {
					let now = new Date().getTime() / 1000;
					// convert scores from 0.0..1.0 to 0..100
					// add answered properties
					_.each(d2.students, function (student, uid) {
						// if a student has no workspace, we don't really have data for them
						// (importantly, assignment.teacherGetAnnotations will return a 409 status,
						// so we want to avoid that)
						let submitted = d.smap[uid].s;
						student.hasWorkspace = submitted !== undefined && submitted !== null;

						_.each(student.answers, function (qset) {
							_.each(qset, function (q) {
								if (typeof q.score === 'number') {
									q.score = Math.round(q.score * 100);
								}
								_.each(q.subQuestions, function (sq, sqid) {
									if (typeof sq.score === 'number') {
										sq.score = Math.round(sq.score * 100);
									}
									sq.questionType = q.questionType;
									sq.qid = parseInt(sqid);
								});
								q.answered = Grading.isAnswered(q);
								_.each(q.subQuestions, function (sq, sqid) {
									sq.answered = q.answered;
								});
							});
						});

						student.overdue = false;

						if (d.edd) {
							// Use student specific edd over assignment
							let duedate = student.edd || d.edd;
							if (student.submitted && duedate < student.timeSubmitted) {
								// Student submitted past the deadline
								student.overdue = true;
							} else if (!student.submitted && duedate < now) {
								// Student hasn't submitted and deadline is past
								student.overdue = true;
							}
						}

						if (!student.firstName && !student.lastName) {
							student.firstName = '[Unknown Name]';
						}
					});

					if (d.edd) {
						d2.deadline = d.edd;
					}
				}
			}
		),

		studentAnswerQuestion: new Mapper({
			aid: 'assignmentId',
			ans: 'answer'
		}),

		createAssignment: new Mapper(
			{
				cc: 'classCode',
				p: 'productId',
				d: 'date',
				ed: 'deadline',
				edd: 'duedate',
				aid: 'aid',
				ccc: 'currentClassCode',
				g: 'selectedGroup',
				ss: 'ss',
				ssp: 'ssp',
				ts: 'textSet',
				'ts.pid': 'textSet.pid',
				'ts.title': 'textSet.title',
				'ts.subType': 'textSet.subType',
				'ts.category': 'textSet.category',
				'ts.book': 'textSet.book',
				gcAddon: 'gcAddon',
				pmd: 'productMetaData'
			},
			{
				postClientToServer: function (d, d2) {
					var qsIds = [],
						srIds = [],
						expressQsIds = [];

					_.each(d.questionSets, function (qs) {
						if (qs.selected) {
							qsIds.push(parseInt(qs.qsid));
							if (qs.fullOrExpress === 'x') {
								expressQsIds.push(parseInt(qs.qsid));
							}
						}
					});

					if (d.stepReads) {
						_.each(d.stepReads, function (sr) {
							if (sr.selected) {
								srIds.push(sr.uuid);
							}
						});
					}

					d2.opts = {
						a: d.assignArticle,
						v: d.assignVocabulary,
						va: d.vocabularyActivities || [],
						au: d.assignAudio,
						bok: d.assignBookOfKnowledge,
						ebook: d.assignEBook,
						qs: qsIds,
						expressqs: expressQsIds,
						sr: srIds,
						ell: d.ell,
						video: d.video || undefined,
						challenge: d.challengeArticles,
						support: d.supportArticles,
						wd: d.wordDetective,
						mm: d.meaningMapper,
						decodables: d.decodables
					};

					if (typeof d.studentChoice !== 'undefined' && d.studentChoice !== null) {
						d2.m = d.studentChoice;
					}

					if (d.showResults !== undefined) {
						d2.shwres = d.showResults;
					}

					var suids = [];
					_.each(d.studentSelections, function (s) {
						if (s.selected) {
							suids.push(s.uid);
						}
					});

					if (d.productType !== 'AAD') {
						// Make due date deadline for A & PT
						d2.edd = d2.ed;
						delete d2.ed;
					}

					// Do not pass null, undefined, or 0 to service
					if (!d2.ed) {
						delete d2.ed;
					}

					if (d.gc) {
						d2.gc = d.gc;
					}
					if (d.token) {
						d2.token = d.token;
					}

					d2.suids = suids;
				},
				postServerToClient(d, d2) {
					d2.productMetaData = beatrice.product.serverToClient(d2.productMetaData);
				}
			}
		)
	},
	assignmentExists: new Mapper({
		cc: 'classCode',
		pid: 'productId'
	}),
	assignmentStatus: new Mapper({
		cc: 'classCode',
		as: 'assignmentStatus',
		aid: 'assignmentId',
		token: 'token',
		shwres: 'shwres'
	}),
	assignmentOptions: new Mapper(OPTIONS_MAP),
	assignmentListParams: new Mapper({
		as: 'assignmentStatus'
	}),
	getAssignments: new Mapper(
		{
			opts: 'options',
			cc: 'classCode',
			aid: 'assignmentId',
			cn: 'className',
			sbm: 'suidsSubmitted',
			ipg: 'suidsInProgress',
			k: 'studentsSubmitted',
			ka: 'studentsInProgress',
			s: 'assignmentStatus',
			c: 'creationTimestamp',
			p: 'productId',
			pmd: 'productMetaData',
			suids: 'studentUids',
			d: 'startDate',
			ed: 'deadline',
			edd: 'duedate',
			m: 'studentChoice',
			t: 'type',
			gcid: 'gcid',
			gca: 'gca',
			'gca.aid': 'gca.attachmentId',
			'gca.iid': 'gca.itemId',
			shwres: 'showResults',
			g: 'group',
			closed: 'closed'
		},
		{
			postServerToClient: function (d, d2) {
				// this is more or less a migration. Old assignments did not have a version number
				// on their productId.
				if (!utils.productIdHasVersion(d2.productId)) {
					d2.productId = utils.buildProductUUIDAndVersion(d2.productId, 1);
				}

				d2.productMetaData = beatrice.product.serverToClient(d2.productMetaData);
				d2.options = beatrice.assignmentOptions.serverToClient(d2.options);

				var suids2 = [];
				if (d.suids) {
					_.each(d.suids, function (state, uid) {
						suids2.push(uid);
					});
					d2.studentUids = suids2;
				}

				if (d2.productMetaData.productType !== 'AAD' && d.edd) {
					// Override deadline with due date
					d2.deadline = d.edd;
				}
			}
		}
	),
	questionSetAssessment: new Mapper(
		{
			cc: 'classCode',
			aid: 'assignmentId',
			qsid: 'questionSetId',
			'sinfo[n].f': 'studentInfo[n].firstName',
			'sinfo[n].l': 'studentInfo[n].lastName',
			'sinfo[n].uid': 'studentInfo[n].uid',
			'sinfo[n].s': 'studentInfo[n].submitted',
			'q[n].qid': 'questions[n].qid',
			'q[n].qt': 'questions[n].questionType',
			'q[n].ans[n].t': 'questions[n].answersByStudent[n].answerText',
			'q[n].ans[n].aid': 'questions[n].answersByStudent[n].answerId',
			'q[n].ans[n].s': 'questions[n].answersByStudent[n].score',
			'q[n].ans[n].r[k].t': 'questions[n].answersByStudent[n].subQuestions[k].answerText',
			'q[n].ans[n].r[k].s': 'questions[n].answersByStudent[n].subQuestions[k].score'
		},
		{
			postServerToClient: function (d, d2) {
				// convert scores from 0..1 to 0..100
				// set answered
				_.each(d2.questions, function (question) {
					question.answersByStudent = _.map(question.answersByStudent, function (answer) {
						if (!answer) {
							return {
								answered: false
							};
						}

						answer.questionType = question.questionType;

						answer.answered = Grading.isAnswered(answer);
						if (typeof answer.score === 'number') {
							answer.score = Math.round(answer.score * 100);
						}

						_.each(answer.subQuestions, function (sq) {
							if (typeof sq.score === 'number') {
								sq.score = Math.round(sq.score * 100);
							}
						});
						return answer;
					});
				});
			}
		}
	),
	studentAssessment: new Mapper(
		{
			aid: 'assignmentId',
			uid: 'uid',
			cc: 'classCode',
			ts: 'timeSubmitted',
			'sc.q[k][k].qt': 'scoring.questionSets[k][k].questionType',
			'sc.q[k][k].t': 'scoring.questionSets[k][k].answerText',
			'sc.q[k][k].s': 'scoring.questionSets[k][k].score',
			'sc.q[k][k].aid': 'scoring.questionSets[k][k].answerId',
			'sc.q[k][k].r[k].t': 'scoring.questionSets[k][k].subQuestions[k].answerText',
			'sc.q[k][k].r[k].s': 'scoring.questionSets[k][k].subQuestions[k].score',
			opts: 'options'
		},
		{
			postServerToClient: function (d, d2) {
				// convert scores from 0.0..1.0 to 0..100
				// add answered properties
				if (d2.scoring && d2.scoring.questionSets) {
					_.each(d2.scoring.questionSets, function (qset) {
						_.each(qset, function (q, qid) {
							if (typeof q.score === 'number') {
								q.score = Math.round(q.score * 100);
							}
							_.each(q.subQuestions, function (sq, sqId) {
								if (typeof sq.score === 'number') {
									sq.score = Math.round(sq.score * 100);
								}
								sq.qid = sqId;
							});
							q.answered = Grading.isAnswered(q);
							q.qid = qid;
						});
					});
				}
			}
		}
	),
	changeStudentUsername: new Mapper({
		u: 'currentUsername',
		nu: 'username'
	}),
	teacherGrade: new Mapper(
		{
			uid: 'uid',
			aid: 'assignmentId',
			'tgrade.qsid': 'teacherGrade.questionSetId',
			'tgrade.qid': 'teacherGrade.questionId',
			'tgrade.qt': 'teacherGrade.questionType',
			'tgrade.s': 'teacherGrade.score',
			'tgrade.sqid': 'teacherGrade.subQuestionId'
		},
		{
			postClientToServer: function (d, d2) {
				if (d2.tgrade && typeof d2.tgrade.s === 'number') {
					d2.tgrade.s = Math.round(d2.tgrade.s / 25) * 0.25;
					if (d2.tgrade.s > 1) {
						throw new Error('Cannot submit score over 1.0 (100)');
					}
					if (d2.tgrade.s < 0) {
						throw new Error('Cannot submit score less than 0');
					}
				}
			}
		}
	),
	studentWorkspace: new Mapper(
		{
			// Most of these client and server property names are identical
			// the intent is to migrate gradually to long names, since the student
			// workspace code is complex.
			'a.m': 'choice.option',
			aid: 'aid',
			as: 'as',
			c: 'c',
			cc: 'cc',
			edd: 'edd',
			'opts.a': 'opts.a',
			'opts.h': 'opts.h',
			'opts.qs': 'opts.qs',
			'opts.expressqs': 'opts.expressqs',
			'opts.bok': 'opts.bok',
			'opts.v': 'opts.v',
			'opts.va': 'opts.vocabularyActivities',
			'opts.ebook': 'opts.ebook',
			'opts.sr': 'opts.sr',
			'opts.au': 'opts.au', // audio assigned (boolean)
			'opts.ell': 'opts.ell',
			'opts.video': 'opts.video',
			'opts.challenge': 'opts.challenge',
			'opts.support': 'opts.support',
			'opts.wd': 'opts.wd',
			'opts.mm': 'opts.mm',
			'opts.decodables': 'opts.decodables',
			shwres: 'showResults',
			p: 'productId',
			'prod.answerMapA': 'prod.answerMapA',
			'prod.img': 'prod.img',
			'prod.lc': 'prod.lc',
			'prod.p': 'prod.p',
			'prod.questionSets[k].p': 'prod.questionSets[k].p',
			'prod.questionSets[k].qsid': 'prod.questionSets[k].qsid',

			// questions have deep properties, but we're ignoring that for the moment
			'prod.questionSets[k].questions': 'prod.questionSets[k].questions',
			'prod.questionSets[k].title': 'prod.questionSets[k].title',
			'prod.r': 'prod.r',
			'prod.s': 'prod.s',
			'prod.t': 'prod.t',
			'prod.title': 'prod.title',
			'prod.wordcount': 'prod.wordcount',
			s: 's',

			// ignoring sc's deep properties for now
			sc: 'scoreState',
			ts: 'ts',
			u: 'u',
			uid: 'uid',
			v: 'v',
			closed: 'closed',
			gcasid: 'gcaSubmissionId'
		},
		{
			postServerToClient: function (d, d2) {
				if (d2.closed && d2.edd && d2.edd > d2.closed) {
					d2.closed = undefined;
				}
			}
		}
	),
	annotations: new Mapper(
		{
			aid: 'assignmentId',
			pid: 'productId',
			uid: 'student',
			hn: 'textNote',
			hs: 'style',
			hrs: 'start',
			hre: 'end',
			hid: 'id',
			'[k].r': '[k].range',
			'[k].c': '[k].created',
			'[k].st': '[k].style',
			'[k].v': '[k].version',
			'[k].n': '[k].textNote'
		},
		{
			postServerToClient: function (d, d2) {
				if (d2) {
					Object.keys(d2).forEach(function (id) {
						var n = d2[id];
						if (Array.isArray(n.range)) {
							n.start = n.range[0];
							n.end = n.range[1];
							delete n.range;
						}
					});
				}
			}
		}
	),
	teacherSideAnnotations: new Mapper(
		{
			aid: 'assignmentId',
			pid: 'productId',
			uid: 'student',
			hn: 'textNote',
			hs: 'style',
			hrs: 'start',
			hre: 'end',
			hid: 'id',
			'[k][k].r': '[k][k].range',
			'[k][k].c': '[k][k].created',
			'[k][k].st': '[k][k].style',
			'[k][k].v': '[k][k].version',
			'[k][k].n': '[k][k].textNote'
		},
		{
			postServerToClient: function (d, d2) {
				Object.keys(d2).forEach(function (productId) {
					Object.keys(d2[productId]).forEach(function (id) {
						var n = d2[productId][id];
						if (Array.isArray(n.range)) {
							n.start = n.range[0];
							n.end = n.range[1];
							delete n.range;
						}
					});
				});
			}
		}
	),
	studentResearchAssessment: new Mapper({
		type: 'type',
		sraid: 'sraid',
		cc: 'classCode',
		d: 'startDate',
		ed: 'deadline',
		sbm: 'suidsSubmitted'
	})
};

beatrice.account.teacherUpdateStudentAccount = new Mapper({
	u: 'currentUsername',
	f: 'firstName',
	l: 'lastName',
	ell: 'ell'
});

beatrice.assignment.updateFutureAssignment = beatrice.assignment.createAssignment;
beatrice.class.getClassRoster = beatrice.roster;
beatrice.class.unEnrollStudent = beatrice.classUnenrollStudent;
beatrice.class.updateClass = beatrice.class;
beatrice.account.teacherUpdateAccount = beatrice.account;
beatrice.account.teacherGetAccount = beatrice.account;
beatrice.account.teacherChangeUsername = beatrice.account;
beatrice.account.initializeGoogleUser = beatrice.studentAccount;
beatrice.account.initializeCleverUser = beatrice.studentAccount;
beatrice.account.teacherSignIn = beatrice.account;
beatrice.account.studentSignInNative = beatrice.studentAccount;
beatrice.account.accountRecovery = beatrice.account;
beatrice.assignment.studentOpenWorkspace = beatrice.studentWorkspace;
beatrice.assignment.studentGetAnnotations = beatrice.annotations;
beatrice.assignment.teacherGetAnnotations = beatrice.teacherSideAnnotations;
beatrice.assignment.createAnnotation = beatrice.annotations;
beatrice.assignment.teacherGetSingleStudentAssignmentResults = beatrice.studentAssessment;
beatrice.assignment.deleteAnnotation = beatrice.annotations;
beatrice.assignment.updateAnnotation = beatrice.annotations;
beatrice.assignment.assignmentExists = beatrice.assignmentExists;
beatrice.account.teacherChangePassword = beatrice.account;
beatrice.account.teacherChangeStudentPassword = beatrice.studentAccount;
beatrice.assignment.teacherGradeQuestion = beatrice.teacherGrade;
beatrice.assignment.teacherGetDetailedAssignmentResults = beatrice.questionSetAssessment;
beatrice.assignment.teacherGetAssignments = beatrice.getAssignments;
beatrice.assignment.teacherUpdateAssignment = beatrice.assignmentStatus;
beatrice.account.teacherCreateAccount = beatrice.account;
beatrice.class.addCoteacher = beatrice.addCoteacher;

var original = beatrice.getAssignments.serverToClient.bind(beatrice.getAssignments);

beatrice.getAssignments.serverToClient = function (d) {
	if (d) {
		var assignments = _.map(d, function (a) {
			return new ReadWorksAssignment(original(a));
		});

		return assignments;
	} else {
		return [];
	}
};

var classMapper = new Mapper({}, {});
classMapper.serverToClient = function (d) {
	return _.map(d, function (c) {
		return beatrice.class.serverToClient(c);
	});
};

beatrice.class.getClasses = classMapper;

var arMap = _.extend(
	{
		t: 'token'
	},
	beatrice.account.map
);

delete arMap.token;

beatrice.account.accountRecoveryCheck = new Mapper(arMap);

var getAccountMap = _.extend(beatrice.account.map, {
	t: 'type'
});

beatrice.account.teacherGetAccount = new Mapper(getAccountMap);

module.exports = beatrice;
